import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { NgModule, Optional, SkipSelf } from '@angular/core'
import { AuthGuard } from './guard/auth.guard'
import { throwIfAlreadyLoaded } from './guard/module-import.guard'
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor'
import { TokenInterceptor } from './interceptors/token.interceptor'

@NgModule({
  providers: [
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule')
  }
}
